<template>
  <div class="container">
    <p>{{ t('additiveAmountCalculationDescription') }}</p>
    <EquationBlock :equations="equations" />
    <hr />
    <div class="row">
      <div class="col-sm">
        <FixedUnitInput
          :input-label="t('startAmount')"
          v-model.number="start"
          :unit="t('units')"
        />
        <FixedUnitInput
          :input-label="t('finalPercentageOfAdditive')"
          v-model.number="percent"
          :unit="t('percent')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :output-label="t('additiveAmountOutput')"
          :number="additiveAmount"
          :unit="t('units')"
        />
        <FixedUnitOutput
           :output-label="t('totalAmountOutput')"
          :number="totalAmount"
          :unit="t('units')"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import { useI18n } from 'vue-i18n';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue'; // Adjust import path as needed
    import FixedUnitOutput from '../inputs/FixedUnitOutput.vue'; // Adjust import path as needed
    import EquationBlock from '../inputs/EquationBlock.vue'; // Adjust import path as needed
    import { defaultRound } from '../../utils/math';
  
  export default {
    components: {
      FixedUnitInput,
      FixedUnitOutput,
      EquationBlock
    },
    setup() {
      const start = ref(200);
      const percent = ref(5);

      const { t, tm } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

      const equations = computed(() => {
          return tm('percentConstituentEquations');
      });
  
      const totalAmount = computed(() => {
        return defaultRound(start.value / (1 - percent.value / 100));
      });
  
      const additiveAmount = computed(() => {
        return defaultRound(totalAmount.value - start.value);
      });
  
      return { start, percent, totalAmount, additiveAmount, equations, t: translations.t };
    },
  };
  </script>
  